import React, { useState } from 'react';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import logo from '../../assets/images/logo.jpg';
import {
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
  Collapse,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Settings as SettingsIcon,
  AccountCircle as AccountIcon,
  Logout as LogoutIcon,
  ExpandLess,
  ExpandMore,
  Group as UsersIcon,
  PersonAdd as AddUserIcon,
  ManageAccounts as ManageUserIcon,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AddIcon from '@mui/icons-material/Add';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import useIsMobile from '../../hooks/useIsMobile';

// Custom hook to detect if device is mobile

const drawerWidth = 240;

export default function Layout() {
  const [open, setOpen] = useState(true);

  const [openOrders, setOpenOrders] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleDrawerToggle = () => setOpen(!open);
  const isMobile = useIsMobile();
  const  token =JSON.parse(localStorage.getItem('token'));

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const menuItems = [
   
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* AppBar */}
      <AppBar
        position="fixed"
        sx={{
          width: { sm: open ? `calc(100% - ${drawerWidth}px)` : '100%' },
          ml: { sm: open ? `${drawerWidth}px` : 0 },
        }}
      >
     <Toolbar>

  <IconButton color="inherit" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
    <MenuIcon />
  </IconButton>

  {/* Welcome Message */}
  <Typography variant="h6" sx={{ flexGrow: 1 }}>
    Welcome {token.name}
  </Typography>

  {/* Logout */}
  <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>
    Logout
  </Button>
</Toolbar>






      </AppBar>

      {/* Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "persistent"}
        open={isMobile ? !open : open}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: isMobile ? true : false, // Better open performance on mobile.
        }}
        sx={{
          // display: { xs: 'block', sm: 'none' },
          display: { xs: isMobile ? 'block' : 'none', sm: isMobile ? 'none' : 'block' },
          width: isMobile ? 'auto' : open ? `${drawerWidth}px` : 0,
          flexShrink: 0,
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {/* Logo at the top of the drawer */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Box
            component={Link}
            to="/"
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Box
              component="img"
              src={logo} // Replace with your logo path
              alt="Logo"
              sx={{ maxHeight: 50, maxWidth: '80%',borderColor:'BLUE', }}
            />
          </Box>
        </Box>
        <Divider />
        <List>
          {menuItems.map(({ text, icon, path }) => (
            <ListItem button key={text} component={Link} to={path} onClick={isMobile ? handleDrawerToggle : undefined}>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}

       


        {/* order Section */}
        <ListItem button onClick={() => setOpenOrders(!openOrders)}>
            <ListItemIcon><SummarizeIcon /></ListItemIcon>
            <ListItemText primary="Orders" />
            {openOrders ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openOrders} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/vanorder/manage" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><ListAltIcon /></ListItemIcon>
                <ListItemText primary="Manage Orders" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/order/create" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><AddIcon /></ListItemIcon>
                <ListItemText primary="Create Order" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/vanload/search" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><SearchIcon /></ListItemIcon>
                <ListItemText primary="Search Product" />
              </ListItem>
            </List>
          </Collapse>




        </List>
      </Drawer>

      {/* Main Content */}
      <Box
  component="main"
  sx={{
    flexGrow: 1,
    p: 1,
    width: '98vw', // Or width: '90vw' for 90% of viewport
    maxWidth: '100%', // Prevent overflow
    transition: (theme) =>
      theme.transitions.create(['margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    ml: open ? 1 : 0,
  }}
>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
